import React, { useEffect, useState } from 'react';
import './Nav.css';

const Nav = () => {
    const [show, handleShow] = useState(false);

    useEffect(() => {
        const handleScrollEvent = () => handleShow(window.scrollY > 100);
        window.addEventListener('scroll', handleScrollEvent);
        return () => (window.removeEventListener('scroll', handleScrollEvent));
    }, []);

    return (
        <div className={`nav ${show && 'nav__black'}`}>
            <img
                className='nav__logo'
                src='https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/1920px-Netflix_2015_logo.svg.png'
                alt='Netflix Logo'
            />
            <img
                className='nav__avatar'
                src='https://i.pinimg.com/originals/0d/dc/ca/0ddccae723d85a703b798a5e682c23c1.png'
                alt='Avatar'
            />
        </div>
    );
}

export default Nav;